import api from "./api";

class CompraAPI {

    async getDadosGraficoFornecedor(headers, params) {
        const response = await api.get("/dash_grafico", {params, headers});
        return response;
    }

    async getDadosGraficoFornecedorGrupo(headers, params) {
        const response = await api.get("/dash_grafico_grupos", {params, headers});
        return response;
    }

    async getProdutosCompra(headers, params) {
        const response = await api.get('/compras_listaprodutos', {params, headers});
        return response;
    }

    async getProdutosCompraGrupo(headers, params) {
        const response = await api.get('/compras_listaprodutos_grupo', {params, headers});
        return response;
    }

    async getProdutosCompraGeral(headers, params) {
        const response = await api.get('/compras_listaprodutosgeral', {params, headers});
        return response;
    }

    async getProdutosCompraGeralGrupo(headers, params) {
        const response = await api.get('/compras_listaprodutosgeral_grupo', {params, headers});
        return response;
    }

    async getProdutosTransito(headers, params) {
        const response = await api.get('/compras_listaprodutos_transito', {params, headers});
        return response;
    }

    async getProdutosTransitoGrupo(headers, params) {
        const response = await api.get('/compras_listaprodutos_transito_grupo', {params, headers});
        return response;
    }

    async getProdutosSobEncomenda(headers, params) {
        const response = await api.get('/compras_listaprodutos_sobencomenda', {params, headers});
        return response;
    }

    async getProdutosSobEncomendaGrupo(headers, params) {
        const response = await api.get('/compras_listaprodutos_sobencomenda_grupo', {params, headers});
        return response;
    }

    async getDetalhesProdutoGrupo(headers, params) {
        const response = await api.get('/compras_detalheproduto_grupo', {params, headers});
        return response;
    }
    
    async getAnaliseProdutoGrupo(headers, params) {
        const response = await api.get('/compras_analiseproduto_grupo', {params, headers});
        return response;
    }

    async getUltimasComprasGrupo(headers, params) {
        const response = await api.get('/compras_listacompras_grupo', {params, headers});
        return response;
    }

    async getUltimasCompras(headers, params) {
        const response = await api.get('/compras_listacompras', {params, headers});
        return response;
    }

    async getTotais(headers, params) {
        const response = await api.get("/compras_get_totais_itens", {params, headers});
        return response;
    }

    async getTotaisGrupo(headers, params) {
        const response = await api.get("/compras_get_totais_itens_grupo", {params, headers});
        return response;
    }

    async getPedido(headers, params) {
        const response = await api.get('/get_pedido', {params, headers});
        return response;
    }

    async getPedidoGrupo(headers, params) {
        const response = await api.get('/get_pedido_grupo', {params, headers});
        return response;
    }

    async getProdutosSimilares(headers, params) {
        const response = await api.get('/listagem_produtos_grupo', {params, headers});
        return response;
    }

    async getSimilares(headers, params) {
        const response = await api.get('/busca_similares_grupo', {params, headers});
        return response;
    }

    async addSimilares(headers, params) {
        const response = await api({
            method: 'post',
            url: '/add_similares',
            headers,
            data: params
        });
        return response;
    }

    async deleteSimilares(headers, params) {
        const response = await api({
            method: 'delete',
            url: '/delete_similares',
            headers,
            data: params
        });
        return response;
    }

    async ajustarTempoRessuprimentoGrupo(headers, params) {
        const response = await api({
            method: 'post',
            url: '/ajuste_ressuprimento_grupo',
            headers,
            data: params
        });
        return response;
    }

    async getDetalhesMovimentacao(headers, params) {
        const response = await api.get('/getDetalhesMovimentacao', {params, headers});
        return response;
    }

    async getDetalhesMovimentacaoGrupo(headers, params) {
        const response = await api.get('/getDetalhesMovimentacaoGrupo', {params, headers});
        return response;
    }

    async getAnaliseTendenciaGrupo(headers, params) {
        const response = await api.get('/getAnaliseTendencia_grupo', {params, headers});
        return response;
    }
    
    async getDetalhamentoEstoqueGrupo(headers, params) {
        const response = await api.get('/getDetalhamentoEstoqueGrupo', {params, headers});
        return response;
    }

    async getFiliais(headers,params) {
        const response = await api.get("/getFiliaisDrpGrupo",{params,headers});
        return response;
    }

    async setFatorAtuacao(headers, params) {
        const response = await api({
            method: 'put',
            url: '/set_fator_atuacao',
            headers,
            data: params
        });
        return response;
    }

}

export default new CompraAPI();
